import PhotoActivityGallery from './PhotoActivityGallery';
import PhotoActivityPanel from './PhotoActivityPanel';

export default PhotoActivityGallery;

export { PhotoActivityGallery, PhotoActivityPanel };
